export const ORGANIZATION_SELECTOR_ROOT_PAGE_SIZE = 250
export const SELECTOR_NODE_PAGE_SIZE = 100
export const SELECTOR_SEARCH_PAGE_SIZE = 100
export const REFERENCE_LOOKUP_PAGE_SIZE = 1000
export const ALARM_PANEL_POINT_LOOKUP_SIZE = 1000
export const ALARM_PANEL_REFRESH_INTERVAL_MS = 10000
